/**
 * @generated SignedSource<<7166b679704bf44cbae2680551558850>>
 * @relayHash 3776d7755b12b1e91d9b17c5a3915dff
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f77087de9d62f3b981bbd1fa090358d49e27008b2b350334b902f0a164bc151a

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type GlobalProductsSettingsSidebarQuery$variables = {
  cloudId: string;
  skipDelegatedAdminCheck: boolean;
};
export type GlobalProductsSettingsSidebarQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"DelegatedAdminJiraSection">;
};
export type GlobalProductsSettingsSidebarQuery = {
  response: GlobalProductsSettingsSidebarQuery$data;
  variables: GlobalProductsSettingsSidebarQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "skipDelegatedAdminCheck"
  }
],
v1 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "GlobalProductsSettingsSidebarQuery",
    "selections": [
      {
        "args": [
          (v1/*: any*/),
          {
            "kind": "Variable",
            "name": "skipDelegatedAdminCheck",
            "variableName": "skipDelegatedAdminCheck"
          }
        ],
        "kind": "FragmentSpread",
        "name": "DelegatedAdminJiraSection"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GlobalProductsSettingsSidebarQuery",
    "selections": [
      {
        "condition": "skipDelegatedAdminCheck",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
              {
                "alias": "canManageCustomOnboarding",
                "args": [
                  (v1/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "key",
                    "value": "MANAGE_CUSTOM_ONBOARDING"
                  }
                ],
                "kind": "ScalarField",
                "name": "hasGlobalPermission"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "f77087de9d62f3b981bbd1fa090358d49e27008b2b350334b902f0a164bc151a",
    "metadata": {},
    "name": "GlobalProductsSettingsSidebarQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "9fba8d87d361bd5696daedb53c760b9b";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
